import styled from 'styled-components';
import { colors, fontSizes, fontWeights, lineHeights } from '@styles/DesignVariables';

export const ProductWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	min-width: 257px;
	width: 100%;
	height: 100%;
`;

export const ProductRatingsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

export const ProductRatings = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 4px;
`;

export const ProductRatingText = styled.div<{ ref: any; $width?: string | undefined }>`
	color: ${colors.greyTitle};
	font-size: ${fontSizes.tinyParagraph};
	font-weight: ${fontWeights.bold};
	line-height: ${lineHeights.tinyParagraph};
	text-transform: uppercase;
	text-wrap: nowrap;
	width: auto;
	flex-shrink: 0;
`;

export const ProductAlign = styled.div<{ $width: number }>`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 4px;
	flex-direction: row;
	width: ${({ $width }) => ($width ? `calc(100% - ${$width}px - 4px)` : '0px')};
`;

export interface TrackProps {
	height: string;
	rounded: boolean;
}

export interface FillProps {
	percent: number;
	height: string;
}

export const Track = styled.div<TrackProps>`
	width: 100%;
	background: #d1d1d1;
	height: ${({ height }) => height};
	${({ rounded }) => rounded && 'border-radius: 9999px;'}
	overflow: hidden;
	max-width: 85px;
`;

export const Fill = styled.div<FillProps>`
	width: ${({ percent }) => percent}%;
	height: ${({ height }) => height};
	background: #00a871;
	transition: width 0.3s ease;
`;
